// extracted by mini-css-extract-plugin
module.exports = {"image":"ArticleHeading_image__tVXSv","title":"ArticleHeading_title__5IVb_","date":"ArticleHeading_date__3rlLo"};